<template lang="html">
  <div>
    <v-toolbar flat color="blue" dense dark>
      <share-link-button/>
      <v-spacer></v-spacer>
      <v-btn text @click="goBackToHomePage()">Posdata Transactions</v-btn>
      <v-spacer></v-spacer>
      <v-btn small text>
        <v-icon small class="mr-1">mdi-account</v-icon>
        {{userName}}
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
  import ShareLinkButton from "@/components/home/ShareLinkButton";
  import {USER_NS} from "@/store/modules/user/constants";
  import {mapGetters} from "vuex";
  import Swal from 'sweetalert2';

  export default {
    components: {ShareLinkButton},
    computed: {
      ...mapGetters(USER_NS, ['userName'])
    },
    beforeMount: function () {
      if (localStorage.getItem("was_warned") !== "true") {
          Swal.fire({
            title: 'Warning: Safe Browsing Program',
            html: 'IMPORTANT: The date has been advanced to September 21st, 2026' +
                'Starting from <b>September 21st, 2026</b>, <b>Posdata dashboard</b> will only be accessible from an authorized browser and a Decathlon computer. ' +
                'Browsers other than Google Chrome and Non-Decathlon computers will be banned.<br><br>' +
                'For more information, please refer to the ' +
                '<a href="https://decathlon.atlassian.net/wiki/spaces/DW/pages/2460255596/2026-09-14+Safe+Browsing+Program+CAB" target="_blank" rel="noopener noreferrer">Safe Browsing Program CAB</a>.',
            icon: 'warning',
            confirmButtonText: 'I\'ve seen the CAB and taken it into account'
          })
        localStorage.setItem("was_warned", "true");
      }
    },
    methods: {
      goBackToHomePage() {
        this.$router.push({name: 'home', params: {}})
      }
    }
  }
</script>

<style lang="css" scoped>
.clickable {
  cursor: pointer;
}
</style>
